<template>
  <v-container :fluid="true" class="pt-2">
    <v-row class="mt-0">
      <v-col class="px-4 pt-0">
        <v-row>
          <v-col class="text-center">
            <v-avatar color="primary" size="64">
              <span class="text-white text-h4">{{ avatar }}</span>
            </v-avatar>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center" v-if="!responsive || !mobileBrokerSearch">
            <span class="text-h5"> {{ name }}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import useFormatters from "@/mixins/formatters";

export default {
  name: "LenderOverview",
  computed: {
    ...mapGetters("user", [
      "responsive",
      "me",
      "isLoanOfficer",
      "myLoanOffice",
    ]),
    ...mapGetters("auth", ["impLoanOffice"]),
    name() {
      if (this.impLoanOffice) {
        return this.impLoanOffice.name;
      } else if (this.myLoanOffice) {
        return this.myLoanOffice.name;
      }

      return this.userName(this.me);
    },
    avatar() {
      let name = this.userName(this.me);
      if (this.impLoanOffice) {
        name = this.impLoanOffice.name;
      } else if (this.myLoanOffice) {
        name = this.myLoanOffice.name;
      }
      if (name !== "") {
        return name.charAt(0).toUpperCase();
      }

      return "-";
    },
  },
  methods: {
    ...useFormatters(),
  },
  data() {
    return {};
  },
};
</script>

<style scoped></style>
